import { Outlet, useLocation } from "react-router-dom";
import DynamicNavbar from "../components/DynamicOrgNavbar";
import Footer from "../components/Footer";
import { useDomain } from '@useDomain';


function PublicLayout() {
 const location = useLocation();
 const { organization: userForDomain } = useDomain(); // ✅ grab org

 const isSaaSRootDomain = ["sportinghip.com", "www.sportinghip.com", "localhost"].includes(window.location.hostname);
 const isFrontendHome = isSaaSRootDomain && (
  location.pathname === "/" ||
  location.pathname === "/browse" ||
  location.pathname === "/millionaire"
 );

 return (
  <>
   {!isFrontendHome && <DynamicNavbar />}
   <Outlet />
   {!isFrontendHome && <Footer userForDomain={userForDomain} />} {/* ✅ pass it in */}
  </>
 );
}


export default PublicLayout;
